<template>
  <div class="container">
    <div class="card">
      <div class="row">
        <div class="col-md-6 my-auto">
          <div class="card-body">
            <div class="row">
              <div class="col-12 text-center">
                <img src="/images/step3.svg" class="img-fluid" style="width:100%;max-width:320px;">
                <h5 class="text-success h3 mt-2 animation-success">¡Gracias por confiar en nosotros!</h5>
                <p class="text-muted animation-success">Hemos recibido correctamente su solicitud de reserva.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card-body bg-light border-bottom border-left"><p class="m-0">Resumen de la Reserva</p></div>
          <ul class="list-group list-group-flush border-left">
            <li class="list-group-item no-slab"><b>Nombre:</b>  {{ this.user.name }}</li>
            <li class="list-group-item no-slab"><b>Apellidos:</b>  {{ this.user.surname }}</li>
            <li class="list-group-item no-slab"><b>NIF:</b>  {{ this.user.cif }}</li>
            <li class="list-group-item no-slab"><b>Correo:</b>  {{ this.user.email }} </li>
            <li class="list-group-item no-slab"><b>Nivel:</b>  {{ this.user.degree.name }} </li>
            <li class="list-group-item no-slab"><b>Fecha de nacimiento:</b>  {{ this.user.birthdate.split(' ', this.user.birthdate.length-1)[0] }} </li>
            <li class="list-group-item no-slab"><b>Días:</b>  {{ this.reservation.days_option }} </li>
            <li class="list-group-item no-slab"><b>Horario:</b>  {{ this.reservation.timetable_option }} </li>
            <li class="list-group-item no-slab"><b>Modalidad:</b>  {{ this.reservation.mode == 2 ? 'Online' : 'Presencial' }} </li>
            
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 text-muted animation-success-alert-text" style="margin-top: 1%">
        <div class="alert alert-warning no-slab d-flex align-items-center">
          <i class="fas fa-info-circle fa-2x"></i>
          <div class="pl-2">
            Debes haber recibido ya un correo de confirmación con el siguiente paso a seguir. Si no lo encuentras en tu bandeja de entrada, búscalo por favor en tus bandejas de promociones o de correo basura.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user", "reservation"],
};
</script>

<style type="text/css">
  .animation-success{
    animation-name: animation-success;
    animation-duration: 0.5s;
    animation-delay: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    position:relative;
    opacity:0;
  }
  @keyframes animation-success{
    0% {
      opacity:0;
      bottom:-500px;
    }
    100%{
      opacity:1;
      bottom:0px;
    }
  }

  .animation-success-alert-text{
    animation-name: animation-success-alert;
    animation-duration: 0.5s;
    animation-delay: 1.5s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    position:relative;
    opacity:0;
  }
  @keyframes animation-success-alert{
    0% {
      opacity:0;
      bottom:-500px;
    }
    100%{
      opacity:1;
      bottom:0px;
    }
  }
</style>